module.exports = __webpack_public_path__ + "static/2-225d2cc7d04218a1ad51f3c2d50f9d23.png";